import React, { useState, useEffect } from 'react';
import { Paper, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const ClockWidget = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Paper 
      variant="outlined" 
      sx={{ 
        py: 0.25, 
        px: 1.5,
        display: 'flex', 
        alignItems: 'center', 
        gap: 1, 
        minWidth: 'auto', 
        justifyContent: 'center',
        borderRadius: 2,
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        boxShadow: 1
      }}
    >
      <AccessTimeIcon fontSize="small" color="primary" />
      <Typography variant="body2" sx={{ fontWeight: 'bold', fontFamily: 'monospace', fontSize: '1rem' }}>
        {time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
      </Typography>
    </Paper>
  );
};

export default ClockWidget;